import { ConfigModel } from "types/business/ConfigModel";
import { BehaviorSubject } from "types/libReplace/BehaviorSubject";
import { createUseDefaultObservable } from "utils/libExtend/createUseDefaultObservable";

type CurrentType = ConfigModel[];

export const useDefaultObservableConfigModelArray = createUseDefaultObservable<CurrentType>();

export class BehaviorSubjectConfigModelArray extends BehaviorSubject<CurrentType> {}
